module.exports = __webpack_public_path__ + "static/media/HomePage-Image-Transparent4.77438b80.jpg";